// server/browser/src/lib/router.svelte.ts
//
// One path-based router for all three namespaces. The cloud serves the
// SPA with a catch-all fallback to index.html (server/hub/webapp.py), so deep
// links and hard refreshes resolve to the bundle and the client router
// reads location.pathname. No hash needed.
//
// The router only resolves the top-level *section* (site / remote /
// admin); each section shell owns its own intra-section route table.
// That keeps the admin and remote route maps inside their lazily-loaded
// chunks rather than the initial public bundle.

export type Section = "site" | "remote" | "admin";

class Router {
  path = $state(typeof window !== "undefined" ? window.location.pathname : "/");
  search = $state(
    new URLSearchParams(typeof window !== "undefined" ? window.location.search : ""),
  );

  get section(): Section {
    if (this.path === "/remote" || this.path.startsWith("/remote/")) return "remote";
    if (this.path === "/admin" || this.path.startsWith("/admin/")) return "admin";
    return "site";
  }

  /** Path segments with the empty leading/trailing entries removed. */
  get segments(): string[] {
    return this.path.split("/").filter(Boolean);
  }

  navigate(to: string): void {
    if (typeof window === "undefined") return;
    history.pushState({}, "", to);
    this.refresh();
    window.scrollTo(0, 0);
  }

  /** Replace the current entry (used after consuming the OIDC callback). */
  replace(to: string): void {
    if (typeof window === "undefined") return;
    history.replaceState({}, "", to);
    this.refresh();
  }

  refresh(): void {
    if (typeof window === "undefined") return;
    this.path = window.location.pathname;
    this.search = new URLSearchParams(window.location.search);
  }

  start(): void {
    if (typeof window === "undefined") return;
    window.addEventListener("popstate", () => this.refresh());
  }
}

export const router = new Router();

/** Shared link click handler: intra-app navigation without a full reload. */
export function go(e: MouseEvent, to: string): void {
  e.preventDefault();
  router.navigate(to);
}
